/**
 * @fileoverview Agent definition for prose-comparer-v2.
 *
 * This agent evaluates multiple text options generated by different models
 * and picks the best one based on quality criteria.
 *
 * Previously known as: option-evaluator
 *
 * @category narrative.prose.judgment
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'prose-comparer-v2',
  kind: 'primitive',
  name: 'Prose Comparer',
  description: 'Evaluates multiple text options and picks the best one.',
  category: 'writing',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2024-06',
    lastUpdated: '2026-01',
    taxonomyPath: 'narrative.prose.judgment',
    usedBy: [
      'use-prose-comparer-v2.ts',
    ],
    usedInComposites: [
      'chapter-drafter-comparison-v2',
    ],
    relatedAgents: [
      'draft-judge-v2',
    ],
  },
};
